(function homePageTypeahead() {
  'use strict';

  const homeSearchBtn = document.querySelector('[data-search-typeahead]');

  function triggerTypeaheadEvent() {
    const form = this.closest('form');
    const inputText = form.querySelector('#SearchText');
    const infoGa4 = inputText.closest('[data-ga4-info-event-name]');
    if (infoGa4) {
      const eventGa4 = {
        eventName: infoGa4.dataset.ga4InfoEventName,
        params: {
          search_value: inputText.value,
          click_target: infoGa4.dataset.ga4InfoEventClick_target

        },
        eventType: 'GA4Event'
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }
  }

  if (homeSearchBtn) {
    homeSearchBtn.addEventListener('click', triggerTypeaheadEvent);
  }
}());
